/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Button, Stack, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import Iconify from '../../components/Iconify';
import Scrollbar from '../../components/Scrollbar';
import { imageHackerthonHandler } from '../../components/editor/EditorToolbar';
import { FormProvider, RHFEditor, RHFTextField } from '../../components/hook-form';
import RHFAutoComplete from '../../components/hook-form/RHFAutoComplete';
import useLocales from '../../hooks/useLocales';
import { setSolution } from '../../redux/slices/hackerthon/hackerthon.solution';
import { getTAGTypes, setTagSearch } from '../../redux/slices/hackerthon/hackerthon.tag';
import { useSelector } from '../../redux/store';
import { createSolutionAPI, updateSolutionAPI } from '../../service/hackerthon/hackerthon.solution.service';

export default function SolutionCreate({ setMode, isEdit, solution }) {
  const { translate } = useLocales();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { topics, search: searchTag, isLoading: isLoadingTag } = useSelector(state => state.hackerthonTag);
  const { exercise } = useSelector((state) => state.hackerthonExercise);

  const NewItemSchema = Yup.object().shape({
    title: Yup.string().required(translate('validation.required')),
    description: Yup.string().required(translate('validation.required')),
    tags: Yup.array().min(1, translate('validation.required')),
  });

  const defaultValues = useMemo(
    () => ({
      title: solution?.title || '',
      description: solution?.description || '',
      tags: solution?.tags || [],
      id: solution?.id || null
    }), []
  );

  const methods = useForm({
    resolver: yupResolver(NewItemSchema),
    defaultValues,
  });

  const { handleSubmit, formState: { isSubmitting }, reset } = methods;

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getTAGTypes());
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchTag]);

  const handleFilterTitleTag = (_, value) => {
    dispatch(setTagSearch({ ...searchTag, page: 0, value }));
  };

  const onSubmit = async (data) => {
    data.exercise = { id: solution?.exercise?.id || exercise?.id };
    let resp;
    if (isEdit) resp = await updateSolutionAPI(data);
    else resp = await createSolutionAPI(data);

    if (resp.code === '200') {
      reset();
      enqueueSnackbar(!isEdit ? translate('message.createSuccess') : translate('message.updateSuccess'));
      setMode("list");
      if (isEdit) {
        dispatch(setSolution({ ...solution, ...data }));
      }
    } else
      enqueueSnackbar(`${resp.code} - ${resp.message}`, { variant: 'error' });
  };

  return (
    <Scrollbar sx={{ flexGrow: 1, p: 1 }}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack mb={2} spacing={2}>
          <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent={"space-between"}>
            <Typography variant='subtitle1'>{translate("hackerthon.solution.newSolution")} </Typography>
            <Button onClick={() => setMode("list")} color='error' startIcon={<Iconify icon="material-symbols:close" width={18} height={18} />}>
              {translate("button.close")}
            </Button>
          </Stack>
          <Typography variant='caption' >Bạn cần nộp bài đúng trước khi chia sẻ giải pháp cho cộng đồng !</Typography>
          <RHFTextField name="title" label={translate('hackerthon.solution.title')} />
          <RHFAutoComplete
            name="tags"
            multiple
            label={translate('hackerthon.solution.tags')}
            options={topics?.map(({ id, title }) => ({ id, title }))}
            loading={isLoadingTag}
            onInputChange={handleFilterTitleTag}
          />
          <RHFEditor name="description" imageHandler={imageHackerthonHandler} />
          <LoadingButton size='large' type="submit" variant="contained" loading={isSubmitting}
            startIcon={<Iconify icon={'tabler:send'} sx={{ height: 20, width: 20 }} />}>
            {translate('button.save')}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Scrollbar>
  );
}
